import {
  ChangeDetectorRef,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { ComplianceData } from '../../../../shared/models/compliance-data.model';
import {
  COMMON_IMPORTS,
  MATERIAL_IMPORTS,
  PIPES_IMPORTS,
} from '../../../../shared/imports/common-imports';
import { ComplianceWheelComponent } from './compliance-wheel/compliance-wheel.component';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-wheel-item',
  standalone: true,
  imports: [
    COMMON_IMPORTS,
    PIPES_IMPORTS,
    MATERIAL_IMPORTS,
    ComplianceWheelComponent,
  ],
  templateUrl: './wheel-item.component.html',
  styleUrl: './wheel-item.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class WheelItemComponent {
  @Input() data!: ComplianceData;
  selectedIndex = -1;
  indexChangedSubject: Subject<number> = new Subject<number>();
  constructor(private cdr: ChangeDetectorRef) {}

  selectItem(index: number) {
    if (this.selectedIndex === index) {
      this.selectedIndex = -1; // Deselect if already selected
      this.indexChangedSubject.next(this.selectedIndex);
      return;
    }
    this.selectedIndex = index;
    this.indexChangedSubject.next(this.selectedIndex);
  }

  selectIndexFromChild(index: number) {
    this.selectedIndex = index;
    this.cdr.detectChanges();
  }

  calculatePercent(value: number): string {
    const total = this.data.elements.reduce((sum, item) => sum + item.value, 0);
    if (total === 0) {
      return '%0';
    }
    const percent = (value / total) * 100;
    return '%' + percent.toFixed(0);
  }
}
